import type { FaqItem } from '@/routes/www/-components/faq-accordion';
import { faqEntriesCa } from './faq/ca';
import { faqEntriesEn } from './faq/en';
import { faqEntriesEs } from './faq/es';
import { faqEntriesFr } from './faq/fr';
import { faqEntriesIt } from './faq/it';

/**
 * Not in the Lingui catalogs: `--strict` fails on any empty `msgstr`, making ten translations a
 * precondition for a page published in five. Typed modules, since the `FAQPage` structured data needs data.
 */

/** In page order. */
export const FAQ_BLOCKS = ['companies', 'ngos', 'donors', 'transparency', 'about'] as const;

export type FaqBlock = (typeof FAQ_BLOCKS)[number];

export type FaqEntry = FaqItem & { block: FaqBlock };

/** Spanish is the SOURCE (Comms wrote it), so a locale without a module falls back to Spanish. */
const entriesByLocale: Partial<Record<string, FaqEntry[]>> = {
	ca: faqEntriesCa,
	en: faqEntriesEn,
	es: faqEntriesEs,
	fr: faqEntriesFr,
	it: faqEntriesIt,
};

export function getFaqEntries(locale: string): FaqEntry[] {
	return entriesByLocale[locale] ?? faqEntriesEs;
}
